import { Point } from './point';

export class Bezier {
    public startPoint: Point;
    public control1: Point;
    public control2: Point;
    public endPoint: Point;
    public constructor(startPoint: Point, control1: Point, control2: Point, endPoint: Point) {
        this.startPoint = startPoint;
        this.control1 = control1;
        this.control2 = control2;
        this.endPoint = endPoint;
    }

    // Returns approximated length.
    public length(): number {
        const steps = 10;
        let length = 0;
        let px = 0;
        let py = 0;

        for (let i = 0; i <= steps; i += 1) {
            const t = i / steps;
            const cx = this.internalPoint(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
            const cy = this.internalPoint(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
            if (i > 0) {
                const xdiff = cx - px;
                const ydiff = cy - py;
                length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
            }
            px = cx;
            py = cy;
        }

        return length;
    }

    public internalPoint(t: number, start: number, c1: number, c2: number, end: number): number {
        const pointCoefficient = 3.0;
        return (
            start * (1.0 - t) * (1.0 - t) * (1.0 - t) +
            pointCoefficient * c1 * (1.0 - t) * (1.0 - t) * t +
            pointCoefficient * c2 * (1.0 - t) * t * t +
            end * t * t * t
        );
    }
}
